(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './FileUpload'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./FileUpload'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.FileUpload);
    global.index = mod.exports;
  }
})(this, function (exports, _FileUpload) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.FileUpload = undefined;

  var _FileUpload2 = _interopRequireDefault(_FileUpload);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.FileUpload = _FileUpload2.default;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/FileUpload/index.js
// module id = 882
// module chunks = 1